// "Decode" text effect: a title resolves left to right out of random glyphs.

const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const LOWER = "abcdefghijkmnopqrstuvwxyz";
const OTHER = "0123456789#$%&*";

/** One frame of the effect: the first `settled` characters are final, the rest
 *  are random stand-ins. Whitespace stays put and stand-ins match the case of
 *  the letter they replace, so the line keeps roughly its final shape. */
export function decodeFrame(
  text: string,
  settled: number,
  random: () => number = Math.random,
): string {
  const chars = Array.from(text);
  if (settled >= chars.length) return text;
  return chars
    .map((ch, i) => {
      if (i < settled || /\s/.test(ch)) return ch;
      const isLetter = ch.toLowerCase() !== ch.toUpperCase();
      const pool = !isLetter ? OTHER : ch === ch.toUpperCase() ? UPPER : LOWER;
      return pool[Math.floor(random() * pool.length)];
    })
    .join("");
}
